module.exports = __webpack_public_path__ + "static/media/whats.2aa236fe.png";